import {
  Button,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDeleteDocumentMutation } from "../../api/admin/chatbotApi";
import { mimeToExtension } from "../../../utils/functions/downloadBlob";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { t } from "i18next";

const DatasetTable = ({ documents = [] }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);

  const [deleteDocument, { isLoading: isDeleting }] =
    useDeleteDocumentMutation();

  const handleDeleteClick = (doc) => {
    setSelectedDoc(doc);
    setOpenDialog(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedDoc) {
      await deleteDocument(selectedDoc.id);
      setOpenDialog(false);
      setSelectedDoc(null);
    }
  };

  const handleCancel = () => {
    setOpenDialog(false);
    setSelectedDoc(null);
  };

  const accessToken = useSelector((state) => state.app.accessToken);

  const handleDownload = async (doc) => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/admin/Chatbot/documents/${doc.id}/download`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );
      const blob = await res.blob();
      if (!blob) {
        alert("Errore durante il download: file non valido.");
        return;
      }

      const url = URL.createObjectURL(blob);

      if (blob.type === "application/pdf") {
        // Apri il PDF in una nuova scheda
        window.open(url, "_blank");
      } else {
        // Estrai estensione dal MIME type del blob
        const extension = mimeToExtension(blob.type);
        const baseName =
          doc.fileName?.split(".").slice(0, -1).join(".") || "file";
        const finalFileName = extension ? `${baseName}.${extension}` : baseName;

        // Scarica il file
        const a = document.createElement("a");
        a.href = url;
        a.download = finalFileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }

      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (e) {
      alert("Errore durante il download del documento.");
    }
  };

  return (
    <TableContainer
      className=" rounded-lg "
      style={{
        border: "1px solid lightgrey",
        transition: "width 0.3s",
        maxHeight: "58rem",
      }}
    >
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#e6e6e6" }}>
            <TableCell>{t("Name")}</TableCell>
            <TableCell>{t("Tipo File")}</TableCell>
            <TableCell>{t("Actions")}</TableCell>
          </TableRow>
        </TableHead>
        {documents?.map((doc) => (
          <TableRow key={doc.id}>
            <TableCell>{doc.fileName}</TableCell>
            <TableCell>{doc.fileName.split(".").pop().toUpperCase()}</TableCell>
            <TableCell>
              <div className="flex">
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => handleDownload(doc)}
                  style={{ marginRight: 8 }}
                >
                  Visualizza
                </Button>
                <Button
                  size="small"
                  color="error"
                  variant="outlined"
                  disabled={isDeleting}
                  onClick={() => handleDeleteClick(doc)}
                >
                  Elimina
                </Button>
              </div>
            </TableCell>
          </TableRow>
        ))}
        {documents?.length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="text-center text-gray">
              {t("NoFileDataset")}
            </TableCell>
          </TableRow>
        )}
      </Table>
      <CoreDialog
        open={openDialog}
        title={t("Delete")}
        content={`${t("DeletingConfirm")} "${selectedDoc?.fileName}"?`}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={handleConfirmDelete}
        closeDialog={handleCancel}
      />
    </TableContainer>
  );
};

export default DatasetTable;
